import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLowKodemScore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 18 18",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m9.896 12.782 6.553-5.129a.32.32 0 0 0 .123-.253V5.847a.16.16 0 0 0-.26-.126L9.5 11.053 2.688 5.72a.16.16 0 0 0-.26.126V7.4c0 .099.047.193.123.253l6.551 5.13c.235.182.56.182.794 0"
	})]
});
const ForwardRef = forwardRef(SvgLowKodemScore);
export { ForwardRef as ReactComponent };
